<script lang="ts">
import { defineComponent } from 'vue';
import router from '../../router';
import InputBox from '../../components/InputBox.vue';
import SolutoButton from '../../components/SolutoButton.vue';
import { mapActions, mapGetters } from 'vuex';

// This is Q9 in e-confluence page
export default defineComponent({
  name: 'SurveyQ52',
  components: {
    InputBox,
    Button: SolutoButton
  },
  computed: {
    ...mapGetters([
      'faqUnhelpfulnessOtherReason',
      'isCallSurvey'
    ]),
    hasValidOtherReason (): boolean {
      return Boolean(this.faqUnhelpfulnessOtherReason?.trim());
    }
  },
  methods: {
    ...mapActions([
      'changeFaqUnhelpfulnessOtherReason'
    ]),
    saveText (event: string) {
      this.changeFaqUnhelpfulnessOtherReason(event);
    },
    nextScreen () {
      if (this.isCallSurvey) {
        router.push({ path: '/survey/question10EnqRating/' });
      } else {
        router.push({ path: '/survey/question6/' });
      }
    },
    goBack () {
      router.go(-1);
    }
  }
});
</script>

<template>
  <div class="mainSurvey">
    <div class="q2">
        <p class="with-margin">{{ isCallSurvey ? $t('survey_052_01_call') : $t('survey_052_01') }}</p>
        <input-box @change="saveText" :text="faqUnhelpfulnessOtherReason"/>
    </div>
    <div class="mainSurvey-footer">
      <Button
        class="footer-button"
        :size="'large'"
        :text="$t('previous')"
        :type="'outlined'"
        @click="goBack()"
      />
      <Button
        class="footer-button"
        :disabled="!hasValidOtherReason"
        :size="'large'"
        :text="$t('next')"
        @click="nextScreen()"
      />
    </div>
  </div>
</template>
